import { useEffect, useState } from "react";
import NewsletterForm from "./NewsletterForm";
import { Reveal } from "./Reveal";
import { api } from "../../lib/api";

export default function NewsletterBand() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.getConfig().then(setCfg).catch(() => {});
  }, []);

  const heading = cfg?.newsletter_heading || "STAY IN THE CULTURE.";
  const sub = cfg?.newsletter_sub || "The report, the drops, the premieres — straight to your inbox before anywhere else.";

  return (
    <section id="newsletter" className="relative bg-burnt overflow-hidden" data-testid="newsletter-band">
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 70% 100% at 20% 50%, rgba(14,12,10,0.6) 0%, transparent 60%)" }}
      />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24 relative">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <p className="font-mono text-[10px] tracking-[0.3em] text-obsidian/70 mb-4">11 — NEWSLETTER</p>
            <h2 className="font-display text-obsidian text-6xl md:text-8xl tracking-tight leading-[0.85] whitespace-pre-line" data-testid="newsletter-heading">
              {heading}
            </h2>
            <p className="mt-5 text-obsidian/80 font-body text-sm md:text-base max-w-md">{sub}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <NewsletterForm source="newsletter-band" dark buttonLabel="GET THE REPORT" testId="newsletter-band" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
